module.exports = function isPrivatePath(path) {
	const privateRoute = process.env.CLF_PRIVATE_ROUTE || "";
	if (privateRoute === "" || !path) return false;
	return privateRoute === "/" || path === privateRoute || path.includes(privateRoute);
};
